<div class="relative p-6 bg-white z-1 dark:bg-gray-900 sm:p-0">
  <div
    class="relative flex flex-col justify-center w-full h-screen lg:flex-row dark:bg-gray-900 sm:p-0"
  >
    <ng-content></ng-content>
    <div
      class="items-center hidden w-full h-full lg:w-1/2 bg-brand-950 dark:bg-white/5 lg:grid relative"
    >
      <div class="flex items-center justify-center z-1">
        <!-- ===== Common Grid Shape Start ===== -->
        <app-grid-shape />
        <div class="flex flex-col items-center max-w-xs">
          <!-- <a routerLink="/" class="block mb-4">
            <img
              width="231"
              height="48"
              src="/images/logo/auth-logo.svg"
              alt="Logo"
            />
          </a> -->
          <p class="text-center text-gray-400 dark:text-white/60">IDMH Perú</p>
          <p class="text-center text-gray-400 dark:text-white/60">
            Fab. Prod. Metal. Uso Estructural
          </p>
          <p class="text-center text-gray-400 dark:text-white/60">
            Activ.de Arquitectura e Ingenieria
          </p>
        </div>
      </div>
    </div>
    <div class="fixed z-50 hidden bottom-6 right-6 sm:block">
      <app-theme-toggle-two />
    </div>
  </div>
</div>
